const fightRounds = {
    round: 0,
    accumulated_damage: 0,
    is_over: true,
}

export default fightRounds;